import React from "react";
import loadable from "@loadable/component";
import retry from "../../../componentLoader";
import { config } from "../../../config";

const CheckIcon = loadable(() => retry(() => import("../icons/CheckIcon")));
const TruckIcon2 = loadable(() => retry(() => import("../icons/TruckIcon2")));
const ExcelIcon = loadable(() => retry(() => import("../icons/ExcelIcon")));
const ExcelBlankIcon = loadable(() =>
    retry(() => import("../icons/ExcelBlankIcon"))
);
const PDFBlankIcon = loadable(() =>
    retry(() => import("../icons/PDFBlankIcon"))
);
const ShopifyIcon = loadable(() => retry(() => import("../icons/ShopifyIcon")));
const MagentoIcon = loadable(() => retry(() => import("../icons/MagentoIcon")));
const RemoveCartIcon = loadable(() =>
    retry(() => import("../icons/RemoveCartIcon"))
);
const TrashIcon = loadable(() => retry(() => import("../icons/TrashIcon")));
const StreamIcon = loadable(() => retry(() => import("../icons/StreamIcon")));
const ReceiptIcon = loadable(() => retry(() => import("../icons/ReceiptIcon")));
const ImageIcon = loadable(() => retry(() => import("../icons/ImageIcon")));
const PlusSquareIcon = loadable(() =>
    retry(() => import("../icons/PlusSquareIcon"))
);
const FacebookIcon = loadable(() =>
    retry(() => import("../icons/FacebookIcon"))
);
const FileIcon = loadable(() => retry(() => import("../icons/FileIcon")));
const InstagramIcon = loadable(() =>
    retry(() => import("../icons/InstagramIcon"))
);
const LinkedinIcon = loadable(() =>
    retry(() => import("../icons/LinkedinIcon"))
);
const LockIcon = loadable(() => retry(() => import("../icons/LockIcon")));
const SendIcon = loadable(() => retry(() => import("../icons/SendIcon")));
const StoreIcon = loadable(() => retry(() => import("../icons/StoreIcon")));
const TwitterIcon = loadable(() => retry(() => import("../icons/TwitterIcon")));
const UserIcon = loadable(() => retry(() => import("../icons/UserIcon")));
const SortIcon = loadable(() => retry(() => import("../icons/SortIcon")));
const EyeIcon = loadable(() => retry(() => import("../icons/EyeIcon")));
const InlineIcon = loadable(() => retry(() => import("../icons/InlineIcon")));
const InlineLargeIcon = loadable(() =>
    retry(() => import("../icons/InlineLargeIcon"))
);
const GripIcon = loadable(() => retry(() => import("../icons/GripIcon")));
const CartPlusIcon = loadable(() =>
    retry(() => import("../icons/CartPlusIcon"))
);
const CartIcon = loadable(() => retry(() => import("../icons/CartIcon")));
const PrintIcon = loadable(() => retry(() => import("../icons/PrintIcon")));
const ShareIcon = loadable(() => retry(() => import("../icons/ShareIcon")));
const MinusIcon = loadable(() => retry(() => import("../icons/MinusIcon")));
const ChevronLeftIcon = loadable(() =>
    retry(() => import("../icons/ChevronLeftIcon"))
);
const ChevronRightIcon = loadable(() =>
    retry(() => import("../icons/ChevronRightIcon"))
);
const CloseIcon = loadable(() => retry(() => import("../icons/CloseIcon")));
const LongArrowLeftIcon = loadable(() =>
    retry(() => import("../icons/LongArrowLeftIcon"))
);
const EllipsisVIcon = loadable(() =>
    retry(() => import("../icons/EllipsisVIcon"))
);
const EllipsisHIcon = loadable(() =>
    retry(() => import("../icons/EllipsisHIcon"))
);
const ImageSolidIcon = loadable(() =>
    retry(() => import("../icons/ImageSolidIcon"))
);
const VideoSolidIcon = loadable(() =>
    retry(() => import("../icons/VideoSolidIcon"))
);
const UploadSolidIcon = loadable(() =>
    retry(() => import("../icons/UploadSolidIcon"))
);
const FileExportIcon = loadable(() =>
    retry(() => import("../icons/FileExportIcon"))
);
const DownloadIcon = loadable(() =>
    retry(() => import("../icons/DownloadIcon"))
);
const LongArrowRighgtIcon = loadable(() =>
    retry(() => import("../icons/LongArrowRighgtIcon"))
);
const ChevronDoubleRightIcon = loadable(() =>
    retry(() => import("../icons/ChevronDoubleRightIcon"))
);
const ChevronDoubleLeftIcon = loadable(() =>
    retry(() => import("../icons/ChevronDoubleLeftIcon"))
);
const FilterIcon = loadable(() => retry(() => import("../icons/FilterIcon")));
const PlusIcon = loadable(() => retry(() => import("../icons/PlusIcon")));
const AngleUpIcon = loadable(() => retry(() => import("../icons/AngleUpIcon")));
const ChevronUpIcon = loadable(() =>
    retry(() => import("../icons/ChevronUpIcon"))
);
const AngleDownIcon = loadable(() =>
    retry(() => import("../icons/AngleDownIcon"))
);
const ChevronDownIcon = loadable(() =>
    retry(() => import("../icons/ChevronDownIcon"))
);
const SyncIcon = loadable(() => retry(() => import("../icons/SyncIcon")));
const EraserIcon = loadable(() => retry(() => import("../icons/EraserIcon")));
const SearchIcon = loadable(() => retry(() => import("../icons/SearchIcon")));
const ListIcon = loadable(() => retry(() => import("../icons/ListIcon")));
const TableIcon = loadable(() => retry(() => import("../icons/TableIcon")));
const PenIcon = loadable(() => retry(() => import("../icons/PenIcon")));
const QuestionIcon = loadable(() =>
    retry(() => import("../icons/QuestionIcon"))
);
const SearchPlusIcon = loadable(() =>
    retry(() => import("../icons/SearchPlusIcon"))
);
const ExternalLinkIcon = loadable(() =>
    retry(() => import("../icons/ExternalLinkIcon"))
);
const ChevronLeftLight = loadable(() =>
    retry(() => import("../icons/ChevronLeftLigthtIcon"))
);
const PlayIcon = loadable(() => retry(() => import("../icons/PlayIcon")));

const icons = [
    CheckIcon,
    ExcelIcon,
    ExcelBlankIcon,
    PDFBlankIcon,
    ShopifyIcon,
    MagentoIcon,
    RemoveCartIcon,
    TrashIcon,
    StreamIcon,
    ImageIcon,
    ReceiptIcon,
    FacebookIcon,
    StoreIcon,
    PlusSquareIcon,
    FileIcon,
    ChevronLeftLight,
    ChevronLeftLight,
    QuestionIcon,
    FileExportIcon,
    PenIcon,
    PlayIcon,
    EraserIcon,
    SyncIcon,
    ChevronUpIcon,
    AngleDownIcon,
    ChevronDownIcon,
    LongArrowRighgtIcon,
    ChevronDoubleRightIcon,
    ChevronDoubleLeftIcon,
    UserIcon,
    MinusIcon,
    EyeIcon,
    SearchPlusIcon,
    GripIcon,
    ListIcon,
    SearchIcon,
    TableIcon,
    UploadSolidIcon,
    ImageSolidIcon,
    SendIcon,
    FilterIcon,
    LockIcon,
];

if (typeof window !== "undefined" && window.__REGISTERED_LOGIN_HANDLERS__) {
    try {
        window.__REGISTERED_LOGIN_HANDLERS__.push(() => {
            console.log("registered all icons");
            icons.map((index) => {
                index.preload();
            });
        });
    } catch (err) {}
}

export default function Icons({ icon, className, onClick, size }) {
    if (icon === "excel") {
        return <ExcelIcon className={className} />;
    }
    if (icon === "shopping-cart") {
        return <CartIcon className={className} />;
    }
    if (icon === "play") {
        return <PlayIcon className={className} />;
    }

    if (icon === "question-circle") {
        return <QuestionIcon />;
    }
    if (icon === "chevron-left-light") {
        return <ChevronLeftLight />;
    }

    if (icon === "sync-alt") {
        return <SyncIcon className={className} />;
    }

    if (icon === "pen") {
        return <PenIcon className={className} />;
    }
    if (icon === "excel-blank") {
        return <ExcelBlankIcon className={className} />;
    }
    if (icon === "pdf-blank") {
        return <PDFBlankIcon className={className} />;
    }
    if (icon === "shopify") {
        return <ShopifyIcon className={className} />;
    }
    if (icon === "magento") {
        return <MagentoIcon className={className} />;
    }
    if (icon === "trash") {
        return <TrashIcon className={className} onClick={onClick} />;
    }

    if (icon === "eraser") {
        return <EraserIcon />;
    }
    if (icon === "external-link") {
        return <ExternalLinkIcon />;
    }

    if (icon === "search") {
        return <SearchIcon className={className} />;
    }
    if (icon === "list") {
        return <ListIcon className={className} />;
    }
    if (icon === "table") {
        return <TableIcon className={className} />;
    }

    if (icon === "receipt") {
        return <ReceiptIcon className={className} />;
    }
    if (icon === "image") {
        return <ImageIcon className={className} />;
    }

    if (icon === "plus-square") {
        return <PlusSquareIcon className={className} />;
    }

    if (icon === "stream") {
        return <StreamIcon className={className} />;
    }

    if (icon === "facebook") {
        return <FacebookIcon className={className} />;
    }

    if (icon === "file") {
        return <FileIcon className={className} />;
    }

    if (icon === "instagram") {
        return <InstagramIcon className={className} />;
    }

    if (icon === "linkedin") {
        return <LinkedinIcon className={className} />;
    }

    if (icon === "lock") {
        return <LockIcon className={className} />;
    }

    if (icon === "send") {
        return <SendIcon className={className} />;
    }

    if (icon === "store") {
        return <StoreIcon className={className} />;
    }

    if (icon === "twitter") {
        return <TwitterIcon className={className} />;
    }

    if (icon === "user") {
        return <UserIcon className={className} />;
    }

    if (icon === "sort") {
        return <SortIcon className={className} />;
    }

    if (icon === "eye") {
        return <EyeIcon className={className} />;
    }

    if (icon === "th") {
        return <InlineIcon className={className} />;
    }

    if (icon === "thlarge") {
        return <InlineLargeIcon className={className} />;
    }

    if (icon === "cart-plus") {
        return <CartPlusIcon className={className} />;
    }

    if (icon === "remove-cart") {
        return <RemoveCartIcon className={className} />;
    }

    if (icon === "grip") {
        return <GripIcon className={className} />;
    }

    if (icon === "print") {
        return <PrintIcon className={className} />;
    }

    if (icon === "share") {
        return <ShareIcon className={className} />;
    }

    if (icon === "minus") {
        return <MinusIcon className={className} />;
    }

    if (icon === "chevron-left") {
        return <ChevronLeftIcon className={className} />;
    }

    if (icon === "chevron-right") {
        return <ChevronRightIcon className={className} />;
    }

    if (icon === "close") {
        return <CloseIcon className={className} />;
    }

    if (icon === "chevron-down") {
        return <ChevronDownIcon className={className} />;
    }

    if (icon === "angle-down") {
        return <AngleDownIcon className={className} />;
    }

    if (icon === "chevron-up") {
        return <ChevronUpIcon className={className} />;
    }

    if (icon === "angle-up") {
        return <AngleUpIcon className={className} />;
    }

    if (icon === "plus") {
        return <PlusIcon className={className} />;
    }

    if (icon === "filter") {
        return <FilterIcon className={className} />;
    }

    if (icon === "chevron-double-left") {
        return <ChevronDoubleLeftIcon className={className} />;
    }
    if (icon === "chevron-double-right") {
        return <ChevronDoubleRightIcon className={className} />;
    }
    if (icon === "file-export") {
        return <FileExportIcon className={className} />;
    }
    if (icon === "upload-solid") {
        return <UploadSolidIcon className={className} />;
    }
    if (icon === "images-solid") {
        return <ImageSolidIcon className={className} size={size} />;
    }
    if (icon === "video-solid") {
        return <VideoSolidIcon className={className} size={size} />;
    }
    if (icon === "ellipsis-v") {
        return <EllipsisVIcon className={className} />;
    }
    if (icon === "ellipsis-h") {
        return <EllipsisHIcon className={className} />;
    }
    if (icon === "long-arrow-left") {
        return <LongArrowLeftIcon className={className} />;
    }
    if (icon === "arrow-left-light") {
        return (
            <svg
                width="20px"
                height="20px"
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="arrow-left"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
            >
                <path
                    fill="currentColor"
                    d="M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"
                />
            </svg>
        );
    }

    if (icon === "check") {
        return <CheckIcon className={className} />;
    }

    if (icon === "check-alt") {
        return (
            <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="check"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="svg-inline--fa fa-check fa-w-16"
            >
                <path
                    fill="currentColor"
                    d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
                />
            </svg>
        );
    }

    if (icon === "globe") {
        return (
            <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="globe"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 496 512"
            >
                <path
                    fill="currentColor"
                    d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm179.3 160h-67.2c-6.7-36.5-17.5-68.8-31.2-94.7 42.9 19 77.7 52.7 98.4 94.7zM248 56c18.6 0 48.6 41.2 63.2 112H184.8C199.4 97.2 229.4 56 248 56zM48 256c0-13.7 1.4-27.1 4-40h77.7c-1 13.1-1.7 26.3-1.7 40s.7 26.9 1.7 40H52c-2.6-12.9-4-26.3-4-40zm20.7 88h67.2c6.7 36.5 17.5 68.8 31.2 94.7-42.9-19-77.7-52.7-98.4-94.7zm67.2-176H68.7c20.7-42 55.5-75.7 98.4-94.7-13.7 25.9-24.5 58.2-31.2 94.7zM248 456c-18.6 0-48.6-41.2-63.2-112h126.5c-14.7 70.8-44.7 112-63.3 112zm70.1-160H177.9c-1.1-12.8-1.9-26-1.9-40s.8-27.2 1.9-40h140.3c1.1 12.8 1.9 26 1.9 40s-.9 27.2-2 40zm10.8 142.7c13.7-25.9 24.4-58.2 31.2-94.7h67.2c-20.7 42-55.5 75.7-98.4 94.7zM366.3 296c1-13.1 1.7-26.3 1.7-40s-.7-26.9-1.7-40H444c2.6 12.9 4 26.3 4 40s-1.4 27.1-4 40h-77.7z"
                />
            </svg>
        );
    }
    if (icon === "playstore") {
        return (
            <svg
                width="99px"
                viewBox="0 0 99 37"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g
                    id="Artboard-Copy"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                >
                    <path
                        d="M4,0 L95,0 C97.209139,-4.05812251e-16 99,1.790861 99,4 L99,33 C99,35.209139 97.209139,37 95,37 L4,37 C1.790861,37 2.705415e-16,35.209139 0,33 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z M18.7304687,18.1523438 L21.078125,15.8046875 L10.109375,9.5078125 L18.7304687,18.1523438 Z M7.859375,9 C7.3515625,9.265625 7.01171875,9.75 7.01171875,10.3789062 L7.01171875,27.6171875 C7.01171875,28.2460938 7.3515625,28.7304688 7.859375,28.9960938 L17.8828125,18.9960938 L7.859375,9 Z M24.46875,17.8125 L22.1679688,16.4804688 L19.6015625,19 L22.1679688,21.5195312 L24.515625,20.1875 C25.21875,19.6289062 25.21875,18.3710938 24.46875,17.8125 Z M10.109375,28.4921875 L21.078125,22.1953125 L18.7304687,19.8476562 L10.109375,28.4921875 Z"
                        fill="#454545"
                    />
                    <path
                        d="M30.735,9.3341339 L33.3826963,9.3341339 C34.0468675,9.3341339 34.6362358,9.46576946 35.1508189,9.72904454 C35.665402,9.99231961 36.0647963,10.3617967 36.3490137,10.8374869 C36.6332311,11.3131771 36.7753377,11.8591655 36.7753377,12.4754685 C36.7753377,13.0917715 36.6332311,13.6377599 36.3490137,14.1134501 C36.0647963,14.5891403 35.665402,14.9586174 35.1508189,15.2218925 C34.6362358,15.4851675 34.0468675,15.6168031 33.3826963,15.6168031 L30.735,15.6168031 L30.735,9.3341339 Z M33.3288449,14.8359571 C33.8374444,14.8359571 34.2847062,14.7372304 34.6706435,14.5397741 C35.0565808,14.3423178 35.3542567,14.0655839 35.56368,13.7095642 C35.7731034,13.3535445 35.8778135,12.9421834 35.8778135,12.4754685 C35.8778135,12.0087536 35.7731034,11.5973925 35.56368,11.2413728 C35.3542567,10.8853531 35.0565808,10.6086192 34.6706435,10.4111629 C34.2847062,10.2137066 33.8374444,10.1149799 33.3288449,10.1149799 L31.6325242,10.1149799 L31.6325242,14.8359571 L33.3288449,14.8359571 Z M38.0228963,10.859925 L38.8845195,10.859925 L38.8845195,15.6168031 L38.0228963,15.6168031 L38.0228963,10.859925 Z M38.0363591,9.78289599 C37.9256639,9.67519255 37.8703172,9.54355698 37.8703172,9.38798535 C37.8703172,9.23241372 37.9256639,9.09928229 38.0363591,8.98858709 C38.1470543,8.87789189 38.2861692,8.82254512 38.4537079,8.82254512 C38.6212466,8.82254512 38.7603614,8.87490017 38.8710566,8.97961185 C38.9817518,9.08432353 39.0370986,9.21446323 39.0370986,9.37003487 C39.0370986,9.53159003 38.9817518,9.66771316 38.8710566,9.77840837 C38.7603614,9.88910357 38.6212466,9.94445034 38.4537079,9.94445034 C38.2861692,9.94445034 38.1470543,9.89059943 38.0363591,9.78289599 Z M40.7693202,15.5135878 C40.4103088,15.4088761 40.1290874,15.2757447 39.9256475,15.1141896 L40.2846572,14.4320712 C40.4940805,14.5816593 40.7483765,14.701328 41.0475527,14.7910809 C41.346729,14.8808337 41.6488924,14.9257095 41.9540522,14.9257095 C42.7079762,14.9257095 43.0849326,14.7103058 43.0849326,14.2794921 C43.0849326,14.1358875 43.0340734,14.0222022 42.9323535,13.9384329 C42.8306336,13.8546636 42.7034856,13.7933334 42.5509057,13.7544404 C42.3983259,13.7155475 42.1814263,13.6721676 41.9002007,13.6242994 C41.5172551,13.5644642 41.2046207,13.4956547 40.9622879,13.4178689 C40.7199552,13.3400831 40.5120309,13.2084475 40.3385086,13.0229582 C40.1649864,12.837469 40.0782266,12.5771896 40.0782266,12.2421122 C40.0782266,11.8112985 40.2577297,11.4657551 40.6167411,11.2054718 C40.9757526,10.9451885 41.4574191,10.8150488 42.0617551,10.8150488 C42.3788818,10.8150488 42.6960039,10.8539411 43.0131307,10.9317269 C43.3302575,11.0095127 43.5905369,11.1142228 43.7939767,11.2458604 L43.4259918,11.9279788 C43.0370627,11.6766707 42.57933,11.5510186 42.0527798,11.5510186 C41.6877848,11.5510186 41.4095551,11.610853 41.2180823,11.7305234 C41.0266096,11.8501939 40.9308746,12.0087549 40.9308746,12.2062113 C40.9308746,12.3617829 40.9847255,12.4844433 41.0924289,12.5741962 C41.2001324,12.663949 41.3332638,12.7297668 41.4918272,12.7716515 C41.6503906,12.8135362 41.8732735,12.8614036 42.1604827,12.9152553 C42.5434283,12.9810741 42.853071,13.0513795 43.0894202,13.1261735 C43.3257694,13.2009676 43.5277104,13.3281156 43.695249,13.5076213 C43.8627877,13.687127 43.9465558,13.9384313 43.9465558,14.2615416 C43.9465558,14.6923554 43.7625652,15.034907 43.3945785,15.2892068 C43.0265917,15.5435066 42.525479,15.6706546 41.8912255,15.6706546 C41.5022964,15.6706546 41.1283317,15.6182995 40.7693202,15.5135878 Z M48.7842111,11.120207 C49.1492061,11.3236468 49.4349151,11.60786 49.6413467,11.972855 C49.8477783,12.33785 49.9509925,12.7596821 49.9509925,13.238364 C49.9509925,13.717046 49.8477783,14.140374 49.6413467,14.5083608 C49.4349151,14.8763475 49.1492061,15.1620565 48.7842111,15.3654963 C48.4192161,15.5689362 48.0063591,15.6706546 47.5456277,15.6706546 C47.2045669,15.6706546 46.8919324,15.6048368 46.607715,15.4731992 C46.3234976,15.3415617 46.0826643,15.1500918 45.885208,14.8987838 L45.885208,17.358 L45.0235848,17.358 L45.0235848,10.859925 L45.8493071,10.859925 L45.8493071,11.6138453 C46.0407798,11.3505702 46.2831089,11.151621 46.5763016,11.0169917 C46.8694943,10.8823624 47.1925998,10.8150488 47.5456277,10.8150488 C48.0063591,10.8150488 48.4192161,10.9167672 48.7842111,11.120207 Z M48.2950604,14.7058161 C48.5373932,14.5652032 48.7288631,14.3677499 48.8694759,14.1134501 C49.0100887,13.8591503 49.0803941,13.5674579 49.0803941,13.238364 C49.0803941,12.9092702 49.0100887,12.6175778 48.8694759,12.363278 C48.7288631,12.1089782 48.5373932,11.9130207 48.2950604,11.7753996 C48.0527277,11.6377786 47.7789856,11.5689691 47.4738258,11.5689691 C47.1746496,11.5689691 46.9038992,11.6392744 46.6615664,11.7798873 C46.4192337,11.9205001 46.2277638,12.1164576 46.087151,12.3677656 C45.9465381,12.6190736 45.8762328,12.9092702 45.8762328,13.238364 C45.8762328,13.5674579 45.9450423,13.8591503 46.0826633,14.1134501 C46.2202844,14.3677499 46.4117543,14.5652032 46.6570788,14.7058161 C46.9024033,14.8464289 47.1746496,14.9167343 47.4738258,14.9167343 C47.7789856,14.9167343 48.0527277,14.8464289 48.2950604,14.7058161 Z M51.9075952,15.3565211 C51.5306332,15.1470977 51.235949,14.858397 51.0235339,14.4904103 C50.8111188,14.1224235 50.7049128,13.705079 50.7049128,13.238364 C50.7049128,12.7716491 50.8111188,12.3543046 51.0235339,11.9863178 C51.235949,11.6183311 51.5306332,11.3311262 51.9075952,11.1246946 C52.2845573,10.918263 52.7093811,10.8150488 53.1820795,10.8150488 C53.654778,10.8150488 54.078106,10.918263 54.4520763,11.1246946 C54.8260465,11.3311262 55.1192348,11.6183311 55.3316499,11.9863178 C55.5440651,12.3543046 55.650271,12.7716491 55.650271,13.238364 C55.650271,13.705079 55.5440651,14.1224235 55.3316499,14.4904103 C55.1192348,14.858397 54.8260465,15.1470977 54.4520763,15.3565211 C54.078106,15.5659444 53.654778,15.6706546 53.1820795,15.6706546 C52.7093811,15.6706546 52.2845573,15.5659444 51.9075952,15.3565211 Z M54.0033142,14.7058161 C54.2456469,14.5652032 54.435621,14.3677499 54.573242,14.1134501 C54.7108631,13.8591503 54.7796726,13.5674579 54.7796726,13.238364 C54.7796726,12.9092702 54.7108631,12.6175778 54.573242,12.363278 C54.435621,12.1089782 54.2456469,11.9130207 54.0033142,11.7753996 C53.7609814,11.6377786 53.4872393,11.5689691 53.1820795,11.5689691 C52.8769198,11.5689691 52.6031777,11.6377786 52.3608449,11.7753996 C52.1185122,11.9130207 51.9270423,12.1089782 51.7864295,12.363278 C51.6458166,12.6175778 51.5755113,12.9092702 51.5755113,13.238364 C51.5755113,13.5674579 51.6458166,13.8591503 51.7864295,14.1134501 C51.9270423,14.3677499 52.1185122,14.5652032 52.3608449,14.7058161 C52.6031777,14.8464289 52.8769198,14.9167343 53.1820795,14.9167343 C53.4872393,14.9167343 53.7609814,14.8464289 54.0033142,14.7058161 Z M60.8244979,11.3401004 C61.1805176,11.6901366 61.3585248,12.2032161 61.3585248,12.8793544 L61.3585248,15.6168031 L60.4969016,15.6168031 L60.4969016,12.978082 C60.4969016,12.5173507 60.386208,12.1703115 60.1648176,11.936954 C59.9434272,11.7035965 59.6263052,11.5869196 59.213442,11.5869196 C58.7467271,11.5869196 58.3787459,11.7230427 58.1094873,11.9952931 C57.8402287,12.2675434 57.7056014,12.6579625 57.7056014,13.1665621 L57.7056014,15.6168031 L56.8439782,15.6168031 L56.8439782,10.859925 L57.6697004,10.859925 L57.6697004,11.5779443 C57.8432226,11.3326198 58.0780724,11.1441416 58.3742569,11.0125041 C58.6704413,10.8808666 59.0070095,10.8150488 59.3839716,10.8150488 C59.9883075,10.8150488 60.4684782,10.9900642 60.8244979,11.3401004 Z M62.9561178,10.859925 L63.817741,10.859925 L63.817741,15.6168031 L62.9561178,15.6168031 L62.9561178,10.859925 Z M62.9695806,9.78289599 C62.8588854,9.67519255 62.8035387,9.54355698 62.8035387,9.38798535 C62.8035387,9.23241372 62.8588854,9.09928229 62.9695806,8.98858709 C63.0802758,8.87789189 63.2193907,8.82254512 63.3869294,8.82254512 C63.5544681,8.82254512 63.6935829,8.87490017 63.8042781,8.97961185 C63.9149733,9.08432353 63.9703201,9.21446323 63.9703201,9.37003487 C63.9703201,9.53159003 63.9149733,9.66771316 63.8042781,9.77840837 C63.6935829,9.88910357 63.5544681,9.94445034 63.3869294,9.94445034 C63.2193907,9.94445034 63.0802758,9.89059943 62.9695806,9.78289599 Z M69.2208365,11.120207 C69.5858315,11.3236468 69.8715405,11.60786 70.0779721,11.972855 C70.2844037,12.33785 70.3876179,12.7596821 70.3876179,13.238364 C70.3876179,13.717046 70.2844037,14.140374 70.0779721,14.5083608 C69.8715405,14.8763475 69.5858315,15.1620565 69.2208365,15.3654963 C68.8558415,15.5689362 68.4429845,15.6706546 67.9822531,15.6706546 C67.6292252,15.6706546 67.3061197,15.6018451 67.012927,15.464224 C66.7197343,15.3266029 66.4774052,15.1261579 66.2859325,14.8628828 L66.2859325,15.6168031 L65.4602102,15.6168031 L65.4602102,8.95717375 L66.3218334,8.95717375 L66.3218334,11.5779443 C66.5133062,11.3266363 66.7526436,11.1366623 67.0398528,11.0080165 C67.3270619,10.8793707 67.6411923,10.8150488 67.9822531,10.8150488 C68.4429845,10.8150488 68.8558415,10.9167672 69.2208365,11.120207 Z M68.7316858,14.7058161 C68.9740186,14.5652032 69.1654885,14.3677499 69.3061013,14.1134501 C69.4467141,13.8591503 69.5170195,13.5674579 69.5170195,13.238364 C69.5170195,12.9092702 69.4467141,12.6175778 69.3061013,12.363278 C69.1654885,12.1089782 68.9740186,11.9130207 68.7316858,11.7753996 C68.4893531,11.6377786 68.215611,11.5689691 67.9104512,11.5689691 C67.611275,11.5689691 67.3390287,11.6377786 67.0937042,11.7753996 C66.8483797,11.9130207 66.6569098,12.1089782 66.5192887,12.363278 C66.3816677,12.6175778 66.3128582,12.9092702 66.3128582,13.238364 C66.3128582,13.5674579 66.3816677,13.8591503 66.5192887,14.1134501 C66.6569098,14.3677499 66.8483797,14.5652032 67.0937042,14.7058161 C67.3390287,14.8464289 67.611275,14.9167343 67.9104512,14.9167343 C68.215611,14.9167343 68.4893531,14.8464289 68.7316858,14.7058161 Z M71.5813251,8.95717375 L72.4429483,8.95717375 L72.4429483,15.6168031 L71.5813251,15.6168031 L71.5813251,8.95717375 Z M78.3666078,13.5255718 L74.5072539,13.5255718 C74.5611056,13.9444185 74.7450962,14.2809867 75.0592312,14.5352865 C75.3733663,14.7895863 75.7637854,14.9167343 76.2305003,14.9167343 C76.7989351,14.9167343 77.2566679,14.7252643 77.6037123,14.3423188 L78.0794001,14.8987838 C77.8639932,15.1500918 77.5962345,15.3415617 77.276116,15.4731992 C76.9559974,15.6048368 76.5984872,15.6706546 76.2035746,15.6706546 C75.7009585,15.6706546 75.2551926,15.5674403 74.8662636,15.3610087 C74.4773345,15.1545771 74.1766669,14.8658764 73.9642518,14.4948979 C73.7518366,14.1239194 73.6456307,13.705079 73.6456307,13.238364 C73.6456307,12.7776327 73.7488449,12.361784 73.9552765,11.9908054 C74.1617081,11.6198269 74.4459213,11.3311262 74.8079245,11.1246946 C75.1699277,10.918263 75.5782971,10.8150488 76.033045,10.8150488 C76.4877928,10.8150488 76.8931705,10.918263 77.2491902,11.1246946 C77.6052099,11.3311262 77.8834396,11.6198269 78.0838877,11.9908054 C78.2843358,12.361784 78.3845583,12.7866078 78.3845583,13.2652898 C78.3845583,13.3311085 78.3785749,13.4178683 78.3666078,13.5255718 Z M74.9964046,11.9190035 C74.7181707,12.1703115 74.5551221,12.4994004 74.5072539,12.9062801 L77.5588361,12.9062801 C77.5109679,12.505384 77.3479193,12.1777909 77.0696854,11.9234911 C76.7914515,11.6691913 76.4459082,11.5420434 76.033045,11.5420434 C75.6201818,11.5420434 75.2746384,11.6676955 74.9964046,11.9190035 Z M86.2737958,13.5255718 L82.4144418,13.5255718 C82.4682936,13.9444185 82.6522842,14.2809867 82.9664192,14.5352865 C83.2805542,14.7895863 83.6709733,14.9167343 84.1376883,14.9167343 C84.7061231,14.9167343 85.1638558,14.7252643 85.5109002,14.3423188 L85.986588,14.8987838 C85.7711812,15.1500918 85.5034225,15.3415617 85.1833039,15.4731992 C84.8631854,15.6048368 84.5056751,15.6706546 84.1107625,15.6706546 C83.6081465,15.6706546 83.1623806,15.5674403 82.7734515,15.3610087 C82.3845224,15.1545771 82.0838548,14.8658764 81.8714397,14.4948979 C81.6590246,14.1239194 81.5528186,13.705079 81.5528186,13.238364 C81.5528186,12.7776327 81.6560329,12.361784 81.8624645,11.9908054 C82.0688961,11.6198269 82.3531092,11.3311262 82.7151124,11.1246946 C83.0771157,10.918263 83.4854851,10.8150488 83.9402329,10.8150488 C84.3949808,10.8150488 84.8003585,10.918263 85.1563782,11.1246946 C85.5123979,11.3311262 85.7906276,11.6198269 85.9910757,11.9908054 C86.1915237,12.361784 86.2917463,12.7866078 86.2917463,13.2652898 C86.2917463,13.3311085 86.2857628,13.4178683 86.2737958,13.5255718 Z M82.9035925,11.9190035 C82.6253586,12.1703115 82.46231,12.4994004 82.4144418,12.9062801 L85.466024,12.9062801 C85.4181558,12.505384 85.2551072,12.1777909 84.9768734,11.9234911 C84.6986395,11.6691913 84.3530961,11.5420434 83.9402329,11.5420434 C83.5273697,11.5420434 83.1818264,11.6676955 82.9035925,11.9190035 Z M91.4659731,11.3401004 C91.8219928,11.6901366 92,12.2032161 92,12.8793544 L92,15.6168031 L91.1383768,15.6168031 L91.1383768,12.978082 C91.1383768,12.5173507 91.0276833,12.1703115 90.8062929,11.936954 C90.5849024,11.7035965 90.2677804,11.5869196 89.8549172,11.5869196 C89.3882023,11.5869196 89.0202211,11.7230427 88.7509625,11.9952931 C88.4817039,12.2675434 88.3470766,12.6579625 88.3470766,13.1665621 L88.3470766,15.6168031 L87.4854534,15.6168031 L87.4854534,10.859925 L88.3111757,10.859925 L88.3111757,11.5779443 C88.4846979,11.3326198 88.7195477,11.1441416 89.0157321,11.0125041 C89.3119166,10.8808666 89.6484848,10.8150488 90.0254468,10.8150488 C90.6297828,10.8150488 91.1099534,10.9900642 91.4659731,11.3401004 Z"
                        fill="#FFFFFF"
                    />
                    <path
                        d="M36.57,19.972 C37.1180027,20.2200012 37.5399985,20.5719977 37.836,21.028 C38.1320015,21.4840023 38.28,22.0239969 38.28,22.648 C38.28,23.2640031 38.1320015,23.8019977 37.836,24.262 C37.5399985,24.7220023 37.1180027,25.0739988 36.57,25.318 C36.0219973,25.5620012 35.3760037,25.684 34.632,25.684 L32.94,25.684 L32.94,28 L30.996,28 L30.996,19.6 L34.632,19.6 C35.3760037,19.6 36.0219973,19.7239988 36.57,19.972 Z M35.856,23.722 C36.1600015,23.4699987 36.312,23.1120023 36.312,22.648 C36.312,22.1759976 36.1600015,21.8140013 35.856,21.562 C35.5519985,21.3099987 35.1080029,21.184 34.524,21.184 L32.94,21.184 L32.94,24.1 L34.524,24.1 C35.1080029,24.1 35.5519985,23.9740013 35.856,23.722 Z M39.648,19.096 L41.52,19.096 L41.52,28 L39.648,28 L39.648,19.096 Z M48.168,22.162 C48.7040027,22.6380024 48.972,23.3559952 48.972,24.316 L48.972,28 L47.22,28 L47.22,27.196 C46.8679982,27.796003 46.2120048,28.096 45.252,28.096 C44.7559975,28.096 44.3260018,28.0120008 43.962,27.844 C43.5979982,27.6759992 43.320001,27.4440015 43.128,27.148 C42.935999,26.8519985 42.84,26.5160019 42.84,26.14 C42.84,25.539997 43.0659977,25.0680017 43.518,24.724 C43.9700023,24.3799983 44.6679953,24.208 45.612,24.208 L47.1,24.208 C47.1,23.799998 46.9760012,23.4860011 46.728,23.266 C46.4799988,23.0459989 46.1080025,22.936 45.612,22.936 C45.2679983,22.936 44.9300017,22.9899995 44.598,23.098 C44.2659983,23.2060005 43.9840012,23.3519991 43.752,23.536 L43.08,22.228 C43.4320018,21.9799988 43.8539975,21.7880007 44.346,21.652 C44.8380025,21.5159993 45.3439974,21.448 45.864,21.448 C46.864005,21.448 47.6319973,21.6859976 48.168,22.162 Z M46.572,26.614 C46.8200012,26.4659993 46.9959995,26.2480014 47.1,25.96 L47.1,25.3 L45.816,25.3 C45.0479962,25.3 44.664,25.5519975 44.664,26.056 C44.664,26.2960012 44.7579991,26.4859993 44.946,26.626 C45.1340009,26.7660007 45.3919984,26.836 45.72,26.836 C46.0400016,26.836 46.3239988,26.7620007 46.572,26.614 Z M57.072,21.544 L54.156,28.396 C53.8599985,29.1400037 53.4940022,29.6639985 53.058,29.968 C52.6219978,30.2720015 52.0960031,30.424 51.48,30.424 C51.1439983,30.424 50.8120016,30.3720005 50.484,30.268 C50.1559984,30.1639995 49.888001,30.0200009 49.68,29.836 L50.364,28.504 C50.5080007,28.6320006 50.6739991,28.7319996 50.862,28.804 C51.0500009,28.8760004 51.2359991,28.912 51.42,28.912 C51.6760013,28.912 51.8839992,28.8500006 52.044,28.726 C52.2040008,28.6019994 52.3479994,28.3960014 52.476,28.108 L52.5,28.048 L49.704,21.544 L51.636,21.544 L53.448,25.924 L55.272,21.544 L57.072,21.544 Z M62.202,27.874 C61.5819969,27.6939991 61.0840019,27.4600014 60.708,27.172 L61.368,25.708 C61.7280018,25.9720013 62.1559975,26.1839992 62.652,26.344 C63.1480025,26.5040008 63.6439975,26.584 64.14,26.584 C64.6920028,26.584 65.0999987,26.5020008 65.364,26.338 C65.6280013,26.1739992 65.76,25.9560014 65.76,25.684 C65.76,25.483999 65.6820008,25.3180007 65.526,25.186 C65.3699992,25.0539993 65.1700012,24.9480004 64.926,24.868 C64.6819988,24.7879996 64.3520021,24.7000005 63.936,24.604 C63.2959968,24.4519992 62.772002,24.3000008 62.364,24.148 C61.955998,23.9959992 61.6060015,23.7520017 61.314,23.416 C61.0219985,23.0799983 60.876,22.6320028 60.876,22.072 C60.876,21.5839976 61.0079987,21.142002 61.272,20.746 C61.5360013,20.349998 61.9339973,20.0360012 62.466,19.804 C62.9980027,19.5719988 63.6479962,19.456 64.416,19.456 C64.9520027,19.456 65.4759974,19.5199994 65.988,19.648 C66.5000026,19.7760006 66.9479981,19.9599988 67.332,20.2 L66.732,21.676 C65.9559961,21.2359978 65.1800039,21.016 64.404,21.016 C63.8599973,21.016 63.4580013,21.1039991 63.198,21.28 C62.9379987,21.4560009 62.808,21.6879986 62.808,21.976 C62.808,22.2640014 62.9579985,22.4779993 63.258,22.618 C63.5580015,22.7580007 64.0159969,22.8959993 64.632,23.032 C65.2720032,23.1840008 65.795998,23.3359992 66.204,23.488 C66.612002,23.6400008 66.9619985,23.8799984 67.254,24.208 C67.5460015,24.5360016 67.692,24.9799972 67.692,25.54 C67.692,26.0200024 67.5580013,26.457998 67.29,26.854 C67.0219987,27.250002 66.6200027,27.5639988 66.084,27.796 C65.5479973,28.0280012 64.8960038,28.144 64.128,28.144 C63.4639967,28.144 62.8220031,28.0540009 62.202,27.874 Z M73.056,27.688 C72.8719991,27.8240007 72.6460013,27.9259997 72.378,27.994 C72.1099987,28.0620003 71.8280015,28.096 71.532,28.096 C70.7639962,28.096 70.1700021,27.900002 69.75,27.508 C69.3299979,27.115998 69.12,26.5400038 69.12,25.78 L69.12,23.128 L68.124,23.128 L68.124,21.688 L69.12,21.688 L69.12,20.116 L70.992,20.116 L70.992,21.688 L72.6,21.688 L72.6,23.128 L70.992,23.128 L70.992,25.756 C70.992,26.0280014 71.0619993,26.2379993 71.202,26.386 C71.3420007,26.5340007 71.5399987,26.608 71.796,26.608 C72.0920015,26.608 72.343999,26.5280008 72.552,26.368 L73.056,27.688 Z M75.354,27.67 C74.8139973,27.3859986 74.3920015,26.9920025 74.088,26.488 C73.7839985,25.9839975 73.632,25.4120032 73.632,24.772 C73.632,24.1319968 73.7839985,23.5600025 74.088,23.056 C74.3920015,22.5519975 74.8139973,22.1580014 75.354,21.874 C75.8940027,21.5899986 76.5039966,21.448 77.184,21.448 C77.8640034,21.448 78.4719973,21.5899986 79.008,21.874 C79.5440027,22.1580014 79.9639985,22.5519975 80.268,23.056 C80.5720015,23.5600025 80.724,24.1319968 80.724,24.772 C80.724,25.4120032 80.5720015,25.9839975 80.268,26.488 C79.9639985,26.9920025 79.5440027,27.3859986 79.008,27.67 C78.4719973,27.9540014 77.8640034,28.096 77.184,28.096 C76.5039966,28.096 75.8940027,27.9540014 75.354,27.67 Z M78.366,26.074 C78.6740015,25.7499984 78.828,25.3160027 78.828,24.772 C78.828,24.2279973 78.6740015,23.7940016 78.366,23.47 C78.0579985,23.1459984 77.6640024,22.984 77.184,22.984 C76.7039976,22.984 76.3080016,23.1459984 75.996,23.47 C75.6839984,23.7940016 75.528,24.2279973 75.528,24.772 C75.528,25.3160027 75.6839984,25.7499984 75.996,26.074 C76.3080016,26.3980016 76.7039976,26.56 77.184,26.56 C77.6640024,26.56 78.0579985,26.3980016 78.366,26.074 Z M84.666,21.688 C85.0460019,21.5279992 85.4839975,21.448 85.98,21.448 L85.98,23.176 C85.771999,23.1599999 85.6320004,23.152 85.56,23.152 C85.0239973,23.152 84.6040015,23.3019985 84.3,23.602 C83.9959985,23.9020015 83.844,24.351997 83.844,24.952 L83.844,28 L81.972,28 L81.972,21.544 L83.76,21.544 L83.76,22.396 C83.9840011,22.0839984 84.2859981,21.8480008 84.666,21.688 Z M93.432,25.3 L88.548,25.3 C88.6360004,25.700002 88.8439984,26.0159988 89.172,26.248 C89.5000016,26.4800012 89.9079976,26.596 90.396,26.596 C90.7320017,26.596 91.0299987,26.5460005 91.29,26.446 C91.5500013,26.3459995 91.7919989,26.1880011 92.016,25.972 L93.012,27.052 C92.403997,27.7480035 91.5160058,28.096 90.348,28.096 C89.6199964,28.096 88.9760028,27.9540014 88.416,27.67 C87.8559972,27.3859986 87.4240015,26.9920025 87.12,26.488 C86.8159985,25.9839975 86.664,25.4120032 86.664,24.772 C86.664,24.1399968 86.8139985,23.5700025 87.114,23.062 C87.4140015,22.5539975 87.8259974,22.1580014 88.35,21.874 C88.8740026,21.5899986 89.4599968,21.448 90.108,21.448 C90.7400032,21.448 91.3119974,21.5839986 91.824,21.856 C92.3360026,22.1280014 92.7379985,22.5179975 93.03,23.026 C93.3220015,23.5340025 93.468,24.1239966 93.468,24.796 C93.468,24.8200001 93.4560001,24.9879984 93.432,25.3 Z M89.052,23.224 C88.7639986,23.4640012 88.5880003,23.7919979 88.524,24.208 L91.704,24.208 C91.6399997,23.799998 91.4640014,23.4740012 91.176,23.23 C90.8879986,22.9859988 90.5360021,22.864 90.12,22.864 C89.6959979,22.864 89.3400014,22.9839988 89.052,23.224 Z"
                        fill="#FFFFFF"
                    />
                </g>
            </svg>
        );
    }
    if (icon === "heart") {
        return (
            <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="heart"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="svg-inline--fa fa-heart fa-w-16"
            >
                <path
                    fill="currentColor"
                    d="M462.3 62.7c-54.5-46.4-136-38.7-186.6 13.5L256 96.6l-19.7-20.3C195.5 34.1 113.2 8.7 49.7 62.7c-62.8 53.6-66.1 149.8-9.9 207.8l193.5 199.8c6.2 6.4 14.4 9.7 22.6 9.7 8.2 0 16.4-3.2 22.6-9.7L472 270.5c56.4-58 53.1-154.2-9.7-207.8zm-13.1 185.6L256.4 448.1 62.8 248.3c-38.4-39.6-46.4-115.1 7.7-161.2 54.8-46.8 119.2-12.9 142.8 11.5l42.7 44.1 42.7-44.1c23.2-24 88.2-58 142.8-11.5 54 46 46.1 121.5 7.7 161.2z"
                />
            </svg>
        );
    }

    if (icon === "search-plus") {
        return <SearchPlusIcon />;
    }

    if (icon === "long-arrow-right") {
        return <LongArrowRighgtIcon />;
    }
    if (icon === "chevron-right-light") {
        return (
            <svg
                width="10px"
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="chevron-right"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 256 512"
            >
                <path
                    fill="currentColor"
                    d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
                />
            </svg>
        );
    }
    if (icon === "chevron-left-light") {
        return (
            <svg
                width="10px"
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="chevron-left"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 256 512"
            >
                <path
                    fill="currentColor"
                    d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"
                />
            </svg>
        );
    }
    if (icon === "pencil") {
        return (
            <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="pencil"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="svg-inline--fa fa-pencil fa-w-16"
            >
                <path
                    fill="currentColor"
                    d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                />
            </svg>
        );
    }
    if (icon === "equal") {
        return (
            <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="equals"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                className="svg-inline--fa fa-equals fa-w-12"
            >
                <path
                    fill="currentColor"
                    d="M376 304H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8zm0-144H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
                />
            </svg>
        );
    }
    if (icon === "close-alt") {
        return (
            <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="times"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                className="svg-inline--fa fa-times fa-w-10"
            >
                <path
                    fill="currentColor"
                    d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
                />
            </svg>
        );
    }
    if (icon === "truck-siluet") {
        return <TruckIcon2 />;
    }

    if (icon === "download") {
        return <DownloadIcon />;
    }

    if ((icon === "ntx-symbol" || icon === "check2") && config.IS_NORITEX) {
        return (
            <svg
                width="310px"
                height="10px"
                viewBox="0 0 365 362"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                >
                    <g id="ntx" fill="currentColor" fillRule="nonzero">
                        <path
                            d="M7.4,360.1 C1.6,356.6 1.5,355.6 1.5,310 C1.5,272.2 1.7,268.2 3.3,265.3 C6.9,258.6 -1.4,259 130,259 C259.7,259 253.8,259.3 257.7,253.4 C259.4,250.7 259.5,244.6 260,129.5 C260.5,12.8 260.6,8.4 262.4,5.7 C266.3,1.13686838e-13 266.2,1.13686838e-13 311.7,1.13686838e-13 C358.5,1.13686838e-13 358.8,1.13686838e-13 362.2,7 C363.9,10.3 364,20.7 364,180.8 C364,368.2 364.4,355.9 357.8,360 C354.5,362 353.3,362 182.5,362 C16,362 10.4,361.9 7.4,360.1 Z"
                            transform="translate(182.752337, 181.000000) scale(-1, 1) rotate(-180.000000) translate(-182.752337, -181.000000) "
                        />
                        <path
                            d="M9.1,360.321489 C7.2,359.321489 4.7,357.221489 3.6,355.721489 C1.6,352.921489 1.5,351.821489 1.5,310.121489 C1.5,271.021489 1.6,267.221489 3.3,264.721489 C7.5,258.321489 4.8,258.521489 66.5,258.021489 C118.7,257.521489 122.8,257.421489 125.4,255.721489 C131,252.021489 131,251.921489 131,192.821489 C131,140.721489 131.1,138.421489 133,135.321489 C136.9,128.921489 136.4,128.921489 184.1,129.221489 L227.2,129.521489 L230.6,133.221489 L234,137.021489 L234,244.721489 C234,328.321489 233.7,353.021489 232.7,354.921489 C232.1,356.221489 230.2,358.321489 228.7,359.421489 C225.9,361.521489 225.7,361.521489 119.2,361.821489 C19.1,362.021489 12.3,361.921489 9.1,360.321489 Z"
                            transform="translate(117.750000, 245.510745) scale(-1, 1) rotate(-180.000000) translate(-117.750000, -245.510745) "
                        />
                        <path
                            d="M5.5,358.484557 C3.7,356.584557 2,353.584557 1.6,351.884557 C0.6,346.584557 0.9,272.784557 2,268.784557 C2.5,266.884557 4.4,263.984557 6.1,262.284557 L9.1,259.384557 L52.3,259.084557 C94.2,258.884557 95.6,258.884557 98.8,260.884557 C105,264.684557 105.1,265.384557 104.8,312.484557 L104.5,355.084557 L100.8,358.484557 L97,361.884557 L52.9,361.884557 L8.7,361.884557 L5.5,358.484557 Z"
                            transform="translate(52.940611, 310.442278) scale(-1, 1) rotate(-180.000000) translate(-52.940611, -310.442278) "
                        />
                    </g>
                </g>
            </svg>
        );
    }

    if (icon === "ntx-symbol" || icon === "check2") {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="33.75"
                zoomAndPan="magnify"
                viewBox="0 0 33.75 33.749998"
                height="33.749998"
                preserveAspectRatio="xMidYMid meet"
                version={1.0}
            >
                <defs>
                    <clipPath id="clip-0">
                        <path
                            d="M 3.597656 3.664062 L 16 3.664062 L 16 16 L 3.597656 16 Z M 3.597656 3.664062 "
                            clipRule="nonzero"
                        />
                    </clipPath>
                    <clipPath id="clip-1">
                        <path
                            d="M 3.597656 18 L 16 18 L 16 29.914062 L 3.597656 29.914062 Z M 3.597656 18 "
                            clipRule="nonzero"
                        />
                    </clipPath>
                    <clipPath id="clip-2">
                        <path
                            d="M 18 3.664062 L 29.847656 3.664062 L 29.847656 16 L 18 16 Z M 18 3.664062 "
                            clipRule="nonzero"
                        />
                    </clipPath>
                    <clipPath id="clip-3">
                        <path
                            d="M 18 18 L 29.847656 18 L 29.847656 29.914062 L 18 29.914062 Z M 18 18 "
                            clipRule="nonzero"
                        />
                    </clipPath>
                </defs>
                <g clipPath="url(#clip-0)">
                    <path
                        fill="rgb(6.669617%, 17.248535%, 33.329773%)"
                        d="M 15.074219 9.433594 C 15.074219 9.808594 15.039062 10.183594 14.964844 10.550781 C 14.890625 10.921875 14.785156 11.28125 14.640625 11.628906 C 14.496094 11.976562 14.320312 12.304688 14.113281 12.621094 C 13.90625 12.933594 13.667969 13.222656 13.402344 13.488281 C 13.140625 13.753906 12.851562 13.992188 12.539062 14.203125 C 12.226562 14.410156 11.898438 14.585938 11.554688 14.730469 C 11.207031 14.875 10.851562 14.984375 10.484375 15.058594 C 10.117188 15.132812 9.746094 15.167969 9.371094 15.167969 C 8.996094 15.167969 8.625 15.132812 8.257812 15.058594 C 7.890625 14.984375 7.535156 14.875 7.1875 14.730469 C 6.839844 14.585938 6.511719 14.410156 6.203125 14.203125 C 5.890625 13.992188 5.601562 13.753906 5.335938 13.488281 C 5.074219 13.222656 4.835938 12.933594 4.628906 12.621094 C 4.417969 12.304688 4.242188 11.976562 4.101562 11.628906 C 3.957031 11.28125 3.847656 10.921875 3.777344 10.550781 C 3.703125 10.183594 3.667969 9.808594 3.667969 9.433594 C 3.667969 9.058594 3.703125 8.683594 3.777344 8.316406 C 3.847656 7.945312 3.957031 7.585938 4.101562 7.238281 C 4.242188 6.890625 4.417969 6.558594 4.628906 6.246094 C 4.835938 5.933594 5.074219 5.644531 5.335938 5.378906 C 5.601562 5.113281 5.890625 4.875 6.203125 4.664062 C 6.511719 4.457031 6.839844 4.28125 7.1875 4.136719 C 7.535156 3.992188 7.890625 3.882812 8.257812 3.808594 C 8.625 3.734375 8.996094 3.699219 9.371094 3.699219 C 9.746094 3.699219 10.117188 3.734375 10.484375 3.808594 C 10.851562 3.882812 11.207031 3.992188 11.554688 4.136719 C 11.898438 4.28125 12.226562 4.457031 12.539062 4.664062 C 12.851562 4.875 13.140625 5.113281 13.402344 5.378906 C 13.667969 5.644531 13.90625 5.933594 14.113281 6.246094 C 14.320312 6.558594 14.496094 6.890625 14.640625 7.238281 C 14.785156 7.585938 14.890625 7.945312 14.964844 8.316406 C 15.039062 8.683594 15.074219 9.058594 15.074219 9.433594 Z M 15.074219 9.433594 "
                        fillOpacity={1}
                        fillRule="nonzero"
                    />
                </g>
                <g clipPath="url(#clip-1)">
                    <path
                        fill="rgb(6.669617%, 17.248535%, 33.329773%)"
                        d="M 15.074219 24.179688 C 15.074219 24.554688 15.039062 24.929688 14.964844 25.296875 C 14.890625 25.667969 14.785156 26.027344 14.640625 26.375 C 14.496094 26.722656 14.320312 27.050781 14.113281 27.363281 C 13.90625 27.679688 13.667969 27.96875 13.402344 28.234375 C 13.140625 28.5 12.851562 28.738281 12.539062 28.945312 C 12.226562 29.15625 11.898438 29.332031 11.554688 29.476562 C 11.207031 29.621094 10.851562 29.730469 10.484375 29.804688 C 10.117188 29.875 9.746094 29.914062 9.371094 29.914062 C 8.996094 29.914062 8.625 29.875 8.257812 29.804688 C 7.890625 29.730469 7.535156 29.621094 7.1875 29.476562 C 6.839844 29.332031 6.511719 29.15625 6.203125 28.945312 C 5.890625 28.738281 5.601562 28.5 5.335938 28.234375 C 5.074219 27.96875 4.835938 27.679688 4.628906 27.363281 C 4.417969 27.050781 4.242188 26.722656 4.101562 26.375 C 3.957031 26.027344 3.847656 25.667969 3.777344 25.296875 C 3.703125 24.929688 3.667969 24.554688 3.667969 24.179688 C 3.667969 23.800781 3.703125 23.429688 3.777344 23.058594 C 3.847656 22.691406 3.957031 22.332031 4.101562 21.984375 C 4.242188 21.636719 4.417969 21.304688 4.628906 20.992188 C 4.835938 20.679688 5.074219 20.390625 5.335938 20.125 C 5.601562 19.859375 5.890625 19.621094 6.203125 19.410156 C 6.511719 19.203125 6.839844 19.023438 7.1875 18.882812 C 7.535156 18.738281 7.890625 18.628906 8.257812 18.554688 C 8.625 18.480469 8.996094 18.445312 9.371094 18.445312 C 9.746094 18.445312 10.117188 18.480469 10.484375 18.554688 C 10.851562 18.628906 11.207031 18.738281 11.554688 18.882812 C 11.898438 19.023438 12.226562 19.203125 12.539062 19.410156 C 12.851562 19.621094 13.140625 19.859375 13.402344 20.125 C 13.667969 20.390625 13.90625 20.679688 14.113281 20.992188 C 14.320312 21.304688 14.496094 21.636719 14.640625 21.984375 C 14.785156 22.332031 14.890625 22.691406 14.964844 23.058594 C 15.039062 23.429688 15.074219 23.800781 15.074219 24.179688 Z M 15.074219 24.179688 "
                        fillOpacity={1}
                        fillRule="nonzero"
                    />
                </g>
                <g clipPath="url(#clip-2)">
                    <path
                        fill="rgb(6.669617%, 17.248535%, 33.329773%)"
                        d="M 29.777344 9.398438 C 29.777344 9.773438 29.742188 10.148438 29.667969 10.515625 C 29.59375 10.886719 29.488281 11.246094 29.34375 11.59375 C 29.199219 11.941406 29.023438 12.269531 28.816406 12.582031 C 28.609375 12.898438 28.371094 13.1875 28.105469 13.453125 C 27.84375 13.71875 27.554688 13.957031 27.242188 14.164062 C 26.929688 14.375 26.601562 14.550781 26.257812 14.695312 C 25.910156 14.839844 25.554688 14.949219 25.1875 15.023438 C 24.820312 15.09375 24.449219 15.132812 24.074219 15.132812 C 23.699219 15.132812 23.328125 15.09375 22.960938 15.023438 C 22.59375 14.949219 22.238281 14.839844 21.890625 14.695312 C 21.542969 14.550781 21.214844 14.375 20.90625 14.164062 C 20.59375 13.957031 20.304688 13.71875 20.039062 13.453125 C 19.773438 13.1875 19.539062 12.898438 19.332031 12.582031 C 19.121094 12.269531 18.945312 11.941406 18.804688 11.59375 C 18.660156 11.246094 18.550781 10.886719 18.480469 10.515625 C 18.40625 10.148438 18.371094 9.773438 18.371094 9.398438 C 18.371094 9.019531 18.40625 8.648438 18.480469 8.277344 C 18.550781 7.910156 18.660156 7.550781 18.804688 7.203125 C 18.945312 6.855469 19.121094 6.523438 19.332031 6.210938 C 19.539062 5.898438 19.773438 5.609375 20.039062 5.34375 C 20.304688 5.078125 20.59375 4.839844 20.90625 4.628906 C 21.214844 4.421875 21.542969 4.242188 21.890625 4.101562 C 22.238281 3.957031 22.59375 3.847656 22.960938 3.773438 C 23.328125 3.699219 23.699219 3.664062 24.074219 3.664062 C 24.449219 3.664062 24.820312 3.699219 25.1875 3.773438 C 25.554688 3.847656 25.910156 3.957031 26.257812 4.101562 C 26.601562 4.242188 26.929688 4.421875 27.242188 4.628906 C 27.554688 4.839844 27.84375 5.078125 28.105469 5.34375 C 28.371094 5.609375 28.609375 5.898438 28.816406 6.210938 C 29.023438 6.523438 29.199219 6.855469 29.34375 7.203125 C 29.488281 7.550781 29.59375 7.910156 29.667969 8.277344 C 29.742188 8.648438 29.777344 9.019531 29.777344 9.398438 Z M 29.777344 9.398438 "
                        fillOpacity={1}
                        fillRule="nonzero"
                    />
                </g>
                <g clipPath="url(#clip-3)">
                    <path
                        fill="rgb(6.669617%, 17.248535%, 33.329773%)"
                        d="M 29.777344 24.179688 C 29.777344 24.554688 29.742188 24.929688 29.667969 25.296875 C 29.59375 25.667969 29.488281 26.027344 29.34375 26.375 C 29.199219 26.722656 29.023438 27.050781 28.816406 27.363281 C 28.609375 27.679688 28.371094 27.96875 28.105469 28.234375 C 27.84375 28.5 27.554688 28.738281 27.242188 28.945312 C 26.929688 29.15625 26.601562 29.332031 26.257812 29.476562 C 25.910156 29.621094 25.554688 29.730469 25.1875 29.804688 C 24.820312 29.875 24.449219 29.914062 24.074219 29.914062 C 23.699219 29.914062 23.328125 29.875 22.960938 29.804688 C 22.59375 29.730469 22.238281 29.621094 21.890625 29.476562 C 21.542969 29.332031 21.214844 29.15625 20.90625 28.945312 C 20.59375 28.738281 20.304688 28.5 20.039062 28.234375 C 19.773438 27.96875 19.539062 27.679688 19.332031 27.363281 C 19.121094 27.050781 18.945312 26.722656 18.804688 26.375 C 18.660156 26.027344 18.550781 25.667969 18.480469 25.296875 C 18.40625 24.929688 18.371094 24.554688 18.371094 24.179688 C 18.371094 23.800781 18.40625 23.429688 18.480469 23.058594 C 18.550781 22.691406 18.660156 22.332031 18.804688 21.984375 C 18.945312 21.636719 19.121094 21.304688 19.332031 20.992188 C 19.539062 20.679688 19.773438 20.390625 20.039062 20.125 C 20.304688 19.859375 20.59375 19.621094 20.90625 19.410156 C 21.214844 19.203125 21.542969 19.023438 21.890625 18.882812 C 22.238281 18.738281 22.59375 18.628906 22.960938 18.554688 C 23.328125 18.480469 23.699219 18.445312 24.074219 18.445312 C 24.449219 18.445312 24.820312 18.480469 25.1875 18.554688 C 25.554688 18.628906 25.910156 18.738281 26.257812 18.882812 C 26.601562 19.023438 26.929688 19.203125 27.242188 19.410156 C 27.554688 19.621094 27.84375 19.859375 28.105469 20.125 C 28.371094 20.390625 28.609375 20.679688 28.816406 20.992188 C 29.023438 21.304688 29.199219 21.636719 29.34375 21.984375 C 29.488281 22.332031 29.59375 22.691406 29.667969 23.058594 C 29.742188 23.429688 29.777344 23.800781 29.777344 24.179688 Z M 29.777344 24.179688 "
                        fillOpacity={1}
                        fillRule="nonzero"
                    />
                </g>
            </svg>
        );
    }

    if (icon === "call") {
        return (
            <svg
                width="22px"
                height="26px"
                viewBox="0 0 22 26"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                    <g
                        transform="translate(-824.000000, -4806.000000)"
                        fill="currentColor"
                        fillRule="nonzero"
                    >
                        <g transform="translate(308.000000, 4806.000000)">
                            <g transform="translate(380.000000, 0.000000)">
                                <path d="M151.714286,17.2857143 L150.579911,17.2857143 C148.308262,18.3333023 145.691738,18.3333023 143.420089,17.2857143 L142.285714,17.2857143 C138.81421,17.2857143 136,20.0999244 136,23.5714286 C136,24.4393046 136.703553,25.1428571 137.571429,25.1428571 L156.428571,25.1428571 C157.296447,25.1428571 158,24.4393046 158,23.5714286 C158,20.0999244 155.18579,17.2857143 151.714286,17.2857143 Z M138.357143,11 C138.791081,11 139.142857,10.6482237 139.142857,10.2142857 L139.142857,9.42857143 C139.142857,5.09633929 142.667768,1.57142857 147,1.57142857 C151.332232,1.57142857 154.857143,5.09633929 154.857143,9.42857143 L154.857143,10.2142857 C154.854707,12.3829661 153.097252,14.1404215 150.928571,14.1428571 L149.357143,14.1428571 C149.357143,13.2749811 148.65359,12.5714286 147.785714,12.5714286 L146.214286,12.5714286 C145.34641,12.5714286 144.642857,13.2749811 144.642857,14.1428571 C144.642857,15.0107332 145.34641,15.7142857 146.214286,15.7142857 L150.928571,15.7142857 C153.964567,15.7104978 156.424784,13.2502815 156.428571,10.2142857 L156.428571,9.42857143 C156.428571,4.22959821 152.198973,0 147,0 C141.801027,0 137.571429,4.22959821 137.571429,9.42857143 L137.571429,10.2142857 C137.571429,10.6482237 137.923205,11 138.357143,11 Z M146.214286,11 L147.785714,11 C148.908275,11.0002741 149.945461,11.5992626 150.506741,12.5714286 L150.928571,12.5714286 C152.229824,12.5700752 153.284361,11.5155388 153.285714,10.2142857 L153.285714,9.42857143 C153.285714,5.95706729 150.471504,3.14285714 147,3.14285714 C143.528496,3.14285714 140.714286,5.95706729 140.714286,9.42857143 C140.714286,11.4134821 141.652232,13.1607143 143.088616,14.3132589 C143.08567,14.2558036 143.071429,14.2012946 143.071429,14.1428571 C143.073323,12.4078904 144.479319,11.0018945 146.214286,11 Z" />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        );
    }

    if (icon === "blue-search") {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={186}
                height="148.194"
                viewBox="0 0 186 148.194"
            >
                <g id="vector" transform="translate(-757 -486.806)">
                    <path
                        id="bg"
                        d="M55.5,195.194a2.5,2.5,0,1,1,0-5H69.173A91.254,91.254,0,0,1,58.03,166.469a92.5,92.5,0,1,1,165.787,23.725H236.5a2.5,2.5,0,1,1,0,5Z"
                        transform="translate(704 439.806)"
                        fill="#dff0fe"
                        opacity="0.628"
                    />
                    <g
                        id="vector-2"
                        data-name="vector"
                        transform="translate(783 496.367)"
                    >
                        <path
                            id="Trazado_5"
                            data-name="Trazado 5"
                            d="M2.5,117.986V3.5H123.887V76.823L80.576,117.986Z"
                            transform="translate(1.223 1.223)"
                            fill="#fff"
                        />
                        <path
                            id="Trazado_6"
                            data-name="Trazado 6"
                            d="M123.365,6.469V77.3L81.1,117.463H5.468V6.469h117.9M126.832,3H2V120.931H82.486l44.347-42.143V3Z"
                            transform="translate(0 0)"
                            fill="#818fa4"
                        />
                        <path
                            id="Trazado_7"
                            data-name="Trazado 7"
                            d="M84.458,36.709V20H81.012V39.982ZM44.022,75.122H19v3.445H40.4Z"
                            transform="translate(42.375 42.364)"
                            fill="#fff"
                        />
                        <path
                            id="Trazado_8"
                            data-name="Trazado 8"
                            d="M3,4H120.942V21.226H3Z"
                            transform="translate(2.445 2.445)"
                            fill="#c5e0f9"
                        />
                        <path
                            id="Trazado_9"
                            data-name="Trazado 9"
                            d="M23.281,16.5H81.848M9.5,16.5h0M23.281,30.281H74.958m-65.458,0h0M23.281,44.061h37.9m-51.677,0h0M23.281,57.842H57.732m-48.232,0h0"
                            transform="translate(18.706 33.44)"
                            fill="none"
                            stroke="#818fa4"
                            strokeLinecap="round"
                            strokeMiterlimit={10}
                            strokeWidth={3}
                        />
                        <path
                            id="Trazado_10"
                            data-name="Trazado 10"
                            d="M87.625,28.335h0A1.728,1.728,0,0,1,85.9,26.613v-6.89A1.728,1.728,0,0,1,87.625,18h0a1.728,1.728,0,0,1,1.723,1.723v6.89A1.728,1.728,0,0,1,87.625,28.335Zm-68.9,51.677h6.89a1.728,1.728,0,0,1,1.723,1.723h0a1.728,1.728,0,0,1-1.723,1.723h-6.89A1.728,1.728,0,0,1,17,81.735h0A1.728,1.728,0,0,1,18.723,80.012Z"
                            transform="translate(37.484 37.474)"
                            fill="#818fa4"
                        />
                        <g
                            id="Grupo_2"
                            data-name="Grupo 2"
                            transform="translate(71.491 97.07)"
                        >
                            <path
                                id="Trazado_11"
                                data-name="Trazado 11"
                                d="M26.856,60.871a4.36,4.36,0,0,1-3.083-7.441L47.547,30.76l5.233,4.889L29.908,59.616A4.292,4.292,0,0,1,26.856,60.871Z"
                                transform="translate(-20.776 -28.397)"
                                fill="#c5e0f9"
                            />
                            <path
                                id="Trazado_12"
                                data-name="Trazado 12"
                                d="M48.785,34.811l2.77,2.591L29.94,60.054a2.635,2.635,0,0,1-3.783-3.669L48.785,34.811m-.021-4.737L23.781,53.894a6.079,6.079,0,0,0,8.6,8.6L56.451,37.264l-7.686-7.19Z"
                                transform="translate(-22 -30.074)"
                                fill="#818fa4"
                            />
                        </g>
                        <g
                            id="Grupo_3"
                            data-name="Grupo 3"
                            transform="translate(87.213 70.977)"
                        >
                            <path
                                id="Trazado_13"
                                data-name="Trazado 13"
                                d="M48.893,22.5A22.393,22.393,0,1,0,71.287,44.893,22.393,22.393,0,0,0,48.893,22.5Z"
                                transform="translate(-26.5 -22.5)"
                                fill="#dff0fe"
                                stroke="#4788c7"
                                strokeMiterlimit={10}
                                strokeWidth={3}
                            />
                            <path
                                id="Trazado_14"
                                data-name="Trazado 14"
                                d="M48.893,22.5A22.393,22.393,0,1,0,71.287,44.893,22.393,22.393,0,0,0,48.893,22.5Z"
                                transform="translate(-26.5 -22.5)"
                                fill="#e8f2fa"
                                stroke="#818fa4"
                                strokeMiterlimit={10}
                                strokeWidth={3}
                            />
                        </g>
                    </g>
                </g>
            </svg>
        );
    }

    if (icon === "blue-emptybox") {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={186}
                height="148.194"
                viewBox="0 0 186 148.194"
            >
                <g id="vetor" transform="translate(-757 -486.806)">
                    <path
                        id="bg"
                        d="M-1714.5,195.194a2.5,2.5,0,0,1-2.5-2.5,2.5,2.5,0,0,1,2.5-2.5h13.674a91.192,91.192,0,0,1-11.143-23.725,92.7,92.7,0,0,1-4-27,93.159,93.159,0,0,1,1.879-18.635,92.046,92.046,0,0,1,5.387-17.357,92.432,92.432,0,0,1,8.526-15.707,93.118,93.118,0,0,1,11.291-13.685A93.118,93.118,0,0,1-1675.2,62.792a92.442,92.442,0,0,1,15.707-8.526,91.981,91.981,0,0,1,17.357-5.387A93.09,93.09,0,0,1-1623.5,47a93.083,93.083,0,0,1,18.635,1.879,91.989,91.989,0,0,1,17.357,5.387,92.507,92.507,0,0,1,15.707,8.526,93.118,93.118,0,0,1,13.684,11.291,93.235,93.235,0,0,1,11.292,13.685,92.5,92.5,0,0,1,8.525,15.707,91.986,91.986,0,0,1,5.388,17.357,93.159,93.159,0,0,1,1.878,18.635A92.279,92.279,0,0,1-1535,166.3a93.048,93.048,0,0,1-11.187,23.9h12.683a2.5,2.5,0,0,1,2.5,2.5,2.5,2.5,0,0,1-2.5,2.5Z"
                        transform="translate(2474 439.806)"
                        fill="#dff0fe"
                        opacity="0.628"
                    />
                    <g
                        id="vector"
                        transform="translate(783 494)"
                        opacity="0.502"
                    >
                        <path
                            id="Trazado_16"
                            data-name="Trazado 16"
                            d="M2.5,128.889V19.5l17-17h92.394l17,17V128.889Z"
                            transform="translate(1.306 1.306)"
                            fill="#dff0fe"
                        />
                        <path
                            id="Trazado_17"
                            data-name="Trazado 17"
                            d="M112.449,5.611l15.939,15.939V128.389H5.611V21.551L21.551,5.611h90.9M113.944,2H20.056L2,20.056V132H132V20.056L113.944,2Z"
                            fill="#112c55"
                        />
                        <path
                            id="Trazado_18"
                            data-name="Trazado 18"
                            d="M32.5,20.556V2.5h1.058l17,17v1.058Z"
                            transform="translate(79.639 1.306)"
                            fill="#98ccfd"
                        />
                        <path
                            id="Trazado_19"
                            data-name="Trazado 19"
                            d="M35.611,7.106,48.561,20.056H35.611V7.106m0-5.106H32V23.667H53.667V20.056L35.611,2Z"
                            transform="translate(78.333)"
                            fill="#112c55"
                        />
                        <path
                            id="Trazado_20"
                            data-name="Trazado 20"
                            d="M2.5,20.556V19.5l17-17h1.058V20.556Z"
                            transform="translate(1.306 1.306)"
                            fill="#98ccfd"
                        />
                        <path
                            id="Trazado_21"
                            data-name="Trazado 21"
                            d="M20.056,7.106V20.056H7.106L20.056,7.106M23.667,2H20.056L2,20.056v3.611H23.667V2Z"
                            fill="#112c55"
                        />
                        <path
                            id="Trazado_22"
                            data-name="Trazado 22"
                            d="M2,7.5H132"
                            transform="translate(0 14.361)"
                            fill="none"
                            stroke="#112c55"
                            strokeMiterlimit={10}
                            strokeWidth={1}
                        />
                        <g
                            id="Grupo_5"
                            data-name="Grupo 5"
                            transform="translate(48.944 38.111)"
                        >
                            <path
                                id="Trazado_23"
                                data-name="Trazado 23"
                                d="M47.5,12H18.611a3.611,3.611,0,1,0,0,7.222H47.5A3.611,3.611,0,0,0,47.5,12Z"
                                transform="translate(-15 -12)"
                                fill="#112c55"
                            />
                        </g>
                        <g
                            id="Grupo_6"
                            data-name="Grupo 6"
                            transform="translate(20.056 2)"
                        >
                            <path
                                id="Trazado_24"
                                data-name="Trazado 24"
                                d="M7.5,2.5H97.778V20.556H7.5Z"
                                transform="translate(-5.694 -0.694)"
                                fill="#b6dcfe"
                            />
                            <path
                                id="Trazado_25"
                                data-name="Trazado 25"
                                d="M97.278,5.611V20.056H10.611V5.611H97.278M100.889,2H7V23.667h93.889V2Z"
                                transform="translate(-7 -2)"
                                fill="#112c55"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        );
    }

    if (icon === 'comment') {
        return (
            <svg className={className} style={{width: 24, height: 24}} viewBox="0 0 24 24">
                <path fill="currentColor" d="M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M6,7H18V9H6V7M6,11H15V13H6V11Z" />
            </svg>
        )
    }
    
    if (icon === 'arrow-right-bottom') {
        return (
            <svg className={className} style={{width: 24, height: 24}} viewBox="0 0 24 24">
                <path fill="currentColor" d="M20 16L14.5 21.5L13.08 20.09L16.17 17H10.5C6.91 17 4 14.09 4 10.5V4H6V10.5C6 13 8 15 10.5 15H16.17L13.09 11.91L14.5 10.5L20 16Z" />
            </svg>

        )
    }

    if (icon === 'ntx-corner-rt') {
        return (
            <svg className={className} width="128" height="128" viewBox="0 0 128 128" fill="none">
                <path d="M105.8 0H2V33.0988H92.896V128H126V0H105.8Z" fill="currentColor"/>
            </svg>
        )
    }

	if (icon === 'ntx-corner-lb') {
		return (
			<svg className={className}  width="128" height="128" viewBox="0 0 128 128" fill="none">
				<g clip-path="url(#clip0_38_21)">
					<path d="M22.2004 128L126 128L126 94.9012L35.104 94.9012L35.104 -7.94638e-06L2.00001 -1.08404e-05L2 128L22.2004 128Z" fill="currentColor"/>
				</g>
				<defs>
					<clipPath id="clip0_38_21">
						<rect width="128" height="128" fill="none" transform="translate(128 128) rotate(-180)"/>
					</clipPath>
				</defs>
			</svg>
		)
	}

    if (icon === 'calendar') {
        return (
            <svg className={className} viewBox="0 0 448 512">
                <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
            </svg>
        )
    }

    return (
        <svg
            width="10px"
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-down"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
        >
            <path
                fill="currentColor"
                d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"
                className={className}
            />
        </svg>
    );
}
